import {getReportParams, report} from '../../../../middleware/report';

export function dwhConfirmationPageDisplay({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Picked Offer Summery';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Picked Offer Summery Page Display';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhShowCurrentPackageClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Picked Offer Summery';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'PopUp Old Plan Open Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhContinueButtonClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Picked Offer Summery';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Picked Offer Summery Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}

export function dwhContractPageDisplay({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber, param6}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Where Send Agreement';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Where Send Agreement Page Display';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.param6 = param6 ? 'Shatap displayed' : '';
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhContractPageEmailButtonClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Where Send Agreement';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Email Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhContractPagePhoneButtonClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Where Send Agreement';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'SMS Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhContractPageButtonClick({
  newOfferId,
  currentOfferId,
  subscriber,
  pageURL,
  customerName,
  id,
  phoneNumber,
  param4,
  shatap,
}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Where Send Agreement';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Aprroval Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param4 = param4;
  reportParams.param5 = phoneNumber;
  reportParams.param6 = shatap;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}

export function dwhSelectPackagesDisplay({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Select Offer';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Offer Page Display';
  reportParams.subscriber = subscriber;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhSelectPackagesOrderButtonClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Select Offer';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Offer Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhSelectAccountDisplay({subscriber, pageURL, customerName, id}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Select Cell Number';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Select Cell Number Page Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param3 = pageURL;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhSelectAccountCurrentPackageClick({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Select Cell Number';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Current Offer Info Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhSelectAccountClick({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Select Cell Number';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Selected Cell Number Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhOpenCurrentPackagePopup({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Picked Offer Summery';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'PopUp Old Plan Display';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId || '';
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhCloseCurrentPackagePopup({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Picked Offer Summery';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'PopUp Old Plan X Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = newOfferId || '';
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhErrorBusinessAccount({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'OTP/Select Cell Number';
  reportParams.status = 'Service';
  reportParams.messageText = 'Buissness Account';
  reportParams.subscriber = subscriber;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}

export function dwhErrorFuturePP({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'OTP/Select Cell Number';
  reportParams.status = 'Service';
  reportParams.messageText = 'Future Plan is set Message Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhErrorPageDisplay({currentOfferId, subscriber, pageURL, customerName, id, message, stepName, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'Error';
  reportParams.status = 'Service';
  reportParams.messageText = message;
  reportParams.subscriber = subscriber;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.report4 = stepName;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}

export function dwhWarningPagePageDisplay({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.actionType = 'OTP/Select Cell Number';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Flex Package Message displayed';
  reportParams.subscriber = subscriber;
  reportParams.param2 = currentOfferId;
  reportParams.param3 = pageURL;
  reportParams.param5 = phoneNumber;
  reportParams.idNumber = id;
  reportParams.customerName = customerName;
  report(reportParams);
}


export function dwhThirdPartyConsentCheckboxDisplay(customerName, subscriber, contactId, process) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'ThirdPartyConsent';
  reportParams.channel = 'WebsitePrivate';
  reportParams.customerName = customerName;
  reportParams.actionType = 'Third Party Consent Approval';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Third Party Consent Displayed';
  reportParams.subscriber = subscriber;
  reportParams.idNumber = contactId;
  reportParams.param1 = "";
  reportParams.param2 = process;
  report(reportParams);
}
